/*
  Live-Vorschau auf der Socke (Pilot seit 2026-10-14, Section-Einstellung „Live-Vorschau auf der Socke“).
  Setzt den Kopf aus dem hochgeladenen Foto bzw. den gezeichneten Kopf aus dem Bild-Dienst in alle Plätze des
  Produktfotos und zeigt das Ergebnis als erstes Bild: Socke links, rechts das Polaroid mit dem eigenen Foto (seit
  2026-10-14, Joel: Vorschau auf dem ersten Bild, Polaroid einheitlich statt eigenes Foto über dem Beispielfoto).
  Nur für Produkte und Farben mit Vorlage: <Bild-Dienst>/vorlagen/index.json (erzeugt mit
  docs/design/socken-vorschau/skripte/vorlage-auto.py, dann buehne.py). Ablauf, Messwerte und Entscheidungen: docs/design/socken-vorschau/README.md.

  Echtes Foto: Der Bild-Dienst stellt frei (art=freistellen, Cloudflare Images/BiRefNet) und holt per SAM 3 die
    Masken (art=sam, fal.ai): „head“, „face“ und „human face“ (Tiere: „head“ 2026-10-14 an 5 Tieren getestet, findet alle;
    „dog head“ auf einem Kaninchen nicht, „animal head“ nur 2 von 5). Ob Mensch oder Tier, entscheidet „human face“: bei
    Menschen genau eine Maske, bei Hund, Katze, Hamster, Vogel, Kaninchen, Pferd keine. „face“ findet auch Tiergesichter
    (Hund 0,71), nimmt aber beim Menschen den Bart mit und bestimmt deshalb weiter die Kinnlinie.
    Mensch: Gesicht am Kinn, Hals weg, lange Haare laufen etwas unter dem Kinn spitz zu (wie skripte/schnitt.py).
    Tier: Kopfmaske plus etwas Hals (HALS), weiche Schnittkante.
    Seit 2026-10-28 zusätzlich „animal“ (in einer zweiten Anfrage, der Bild-Dienst nimmt 3 Begriffe): Tierköpfe sind nur
    noch Kopfmasken auf einem Tier (vorher jeder Kopf ohne Menschengesicht – beim Pony mit Person dahinter wurde so die
    Person geschnitten, beim Mann nur das Haar). Liegt auf einem Tier kein Kopf (Mädchen mit Hund), kommt „animal head“
    dazu. Mehrere Menschen/Tiere: alle zusammen als ein Motiv (schnittGruppe), wer klein im Hintergrund steht, bleibt draußen.
    Außenkanten (Haare, Fell) kommen vom Freisteller, die Pixel immer aus dem Original.
  Gezeichnete Stile: der transparente Kopf aus dem Bild-Dienst.
  Logo-Produkte (seit 2026-10-15): das Logo im weißen Kreis an den Plätzen der „Dein Logo“-Kreise (logoKreis, skripte/kreise.py).
  Seit 2026-10-14 ohne MediaPipe im Browser (Joel: 20 MB Download zu viel) und ohne KI-Umriss bei OpenAI (zu langsam).
*/
(function () {
  'use strict';

  var MAX_SIDE = 1536;      // so groß geht das Foto zum Freistellen (dort ebenfalls die Grenze)
  var SAM_SIDE = 1024;      // so groß geht das Foto an SAM 3
  var MIN_FACE = 40;        // kleinere Gesichter (Ganzkörperfoto): keine Vorschau
  var CROP_MAX = 1000;      // größter Ausschnitt um den Kopf beim Schnitt
  var HALS = 0.10;          // Tiere: so viel Hals unter der Kopfmaske (Anteil der Kopfhöhe), Joel 2026-10-14 „etwas mehr vom hals“
  var RAND = 0.03;          // Tiere: so weit über die Kopfmaske hinaus kommt Fell vom Freisteller dazu (Anteil der Kopfhöhe), Joel 2026-10-14 nach Abstufung „hals 10 rand 3“
  var GEZEICHNET = 1.3;     // gezeichnete Köpfe auf Menschen-Vorlagen: so viel größer als „ganzer Umriss = Kopfhöhe“ (das Gesicht stand
                            // 1,45–1,76× kleiner als beim Foto); Joel 2026-10-15 nach Vergleich ×1,1–×1,4: „1,3“
  var SAM_JE_ANFRAGE = 3;   // so viele Begriffe nimmt der Bild-Dienst je Anfrage, weitere gehen parallel in einer zweiten
  // Mehrere Menschen/Tiere auf einem Foto (seit 2026-10-28, Joel: immer zusammen, ohne Auswahl, ohne Aufpreis, ohne Vermerk)
  var GRUPPE = 0.625;       // Gesichter in der Gruppe so groß wie ein einzelnes × GRUPPE, auf allen Produkten (Joel: „auf den socken passt
                            // die alte größe“; die Gruppe auf Hoodies nicht extra vergrößern, die Angleichung der Modelle reicht)
  var NEBEN = 0.45;         // Köpfe kleiner als NEBEN × der größte: im Hintergrund, bleiben draußen (gemessen: Gruppen ab 0,73, Person hinter dem Pony 0,17)
  var MENSCH_KOPF = 1.45;   // Mensch: Kopfhöhe ≈ Gesicht × MENSCH_KOPF (zum Vergleich mit Tierköpfen)
  var TIER_GESICHT = 0.85;  // Tier in der Gruppe: Gesichtshöhe ≈ Kopfmaske × TIER_GESICHT („animal face“ gemessen 0,69–1,0)
  var VORN = 0.5;           // Mensch/Tier zählt nur, wenn der Freisteller es zu mindestens VORN behält (gemessen: echte Tiere 0,99,
                            // Hello Kitty an der Wand hinter einem Kind und Aufkleber 0,00, angeschnittene Person am Bildrand 0,00)
  // Kopfgröße auf Hoodies und Onesies angleichen (seit 2026-10-28, Joel: „manche sind viel kleiner“, etwa Best Sister neben
  // Best Brother): Gesicht bzw. Tierkopf als Anteil der Höhe des Kleidungsstücks (Druckmaske vorn), nie verkleinern. Vorher
  // 5,1–8,9 %; Best Brother und die meisten Hoodies haben 8 %. Menschen auf Tiermotiven nach dem Gesicht (vorher 5,2 %).
  var ZIEL = { hoodie: { mensch: 0.08, tier: 0.08 }, onesie: { mensch: 0.065, tier: 0.08 } };

  /* ---------- Bildhelfer (Masken als Uint8Array 0/1, Werte als Float32Array, zeilenweise w × h) ---------- */

  function canvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
  function ctx2d(c) { return c.getContext('2d', { willReadFrequently: true }); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function boxH(src, dst, w, h, r) {
    var inv = 1 / (2 * r + 1);
    for (var y = 0; y < h; y++) {
      var o = y * w, acc = 0, x;
      for (x = -r; x <= r; x++) acc += src[o + clamp(x, 0, w - 1)];
      for (x = 0; x < w; x++) {
        dst[o + x] = acc * inv;
        acc += src[o + Math.min(x + r + 1, w - 1)] - src[o + Math.max(x - r, 0)];
      }
    }
  }
  function boxV(src, dst, w, h, r) {
    var inv = 1 / (2 * r + 1);
    for (var x = 0; x < w; x++) {
      var acc = 0, y;
      for (y = -r; y <= r; y++) acc += src[clamp(y, 0, h - 1) * w + x];
      for (y = 0; y < h; y++) {
        dst[y * w + x] = acc * inv;
        acc += src[Math.min(y + r + 1, h - 1) * w + x] - src[Math.max(y - r, 0) * w + x];
      }
    }
  }
  // Gaußscher Weichzeichner, angenähert durch drei Boxfilter
  function blur(src, w, h, sigma) {
    var a = Float32Array.from(src);
    if (sigma < 0.5) return a;
    var b = new Float32Array(w * h);
    var wl = Math.floor(Math.sqrt(4 * sigma * sigma + 1)); if (wl % 2 === 0) wl--;
    var m = Math.round((12 * sigma * sigma - 3 * wl * wl - 12 * wl - 9) / (-4 * wl - 4));
    for (var i = 0; i < 3; i++) {
      var r = ((i < m ? wl : wl + 2) - 1) / 2;
      boxH(a, b, w, h, r); boxV(b, a, w, h, r);
    }
    return a;
  }
  // Exakter euklidischer Abstand zum nächsten gesetzten Pixel (Felzenszwalb & Huttenlocher)
  function edt(mask, w, h) {
    var INF = 1e20, g = new Float64Array(w * h), n = Math.max(w, h);
    var f = new Float64Array(n), d = new Float64Array(n), v = new Int32Array(n), z = new Float64Array(n + 1);
    for (var i = 0; i < w * h; i++) g[i] = mask[i] ? 0 : INF;
    function dt(len) {
      var k = 0, q, s; v[0] = 0; z[0] = -INF; z[1] = INF;
      for (q = 1; q < len; q++) {
        s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        while (s <= z[k]) { k--; s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]); }
        k++; v[k] = q; z[k] = s; z[k + 1] = INF;
      }
      for (k = 0, q = 0; q < len; q++) { while (z[k + 1] < q) k++; d[q] = (q - v[k]) * (q - v[k]) + f[v[k]]; }
    }
    var x, y;
    for (x = 0; x < w; x++) { for (y = 0; y < h; y++) f[y] = g[y * w + x]; dt(h); for (y = 0; y < h; y++) g[y * w + x] = d[y]; }
    for (y = 0; y < h; y++) { for (x = 0; x < w; x++) f[x] = g[y * w + x]; dt(w); for (x = 0; x < w; x++) g[y * w + x] = d[x]; }
    return g;   // quadrierte Abstände
  }
  function dilate(mask, w, h, r) {
    var d = edt(mask, w, h), out = new Uint8Array(w * h), rr = r * r;
    for (var i = 0; i < w * h; i++) out[i] = d[i] <= rr ? 1 : 0;
    return out;
  }
  function erode(mask, w, h, r) {
    var inv = new Uint8Array(w * h);
    for (var i = 0; i < w * h; i++) inv[i] = mask[i] ? 0 : 1;
    var d = dilate(inv, w, h, r);
    for (i = 0; i < w * h; i++) d[i] = d[i] ? 0 : 1;
    return d;
  }
  function open(mask, w, h, r) { return dilate(erode(mask, w, h, r), w, h, r); }
  // Zusammenhängende Stücke (8er-Nachbarschaft): Label je Pixel, Fläche und x-Summe je Stück
  function components(mask, w, h) {
    var lab = new Int32Array(w * h), stack = new Int32Array(w * h), area = [0], sumX = [0], n = 0;
    for (var i = 0; i < w * h; i++) {
      if (!mask[i] || lab[i]) continue;
      n++; var sp = 0, a = 0, sx = 0;
      stack[sp++] = i; lab[i] = n;
      while (sp) {
        var p = stack[--sp], px = p % w, py = (p - px) / w;
        a++; sx += px;
        for (var dy = -1; dy <= 1; dy++) {
          var yy = py + dy; if (yy < 0 || yy >= h) continue;
          for (var dx = -1; dx <= 1; dx++) {
            var xx = px + dx; if (xx < 0 || xx >= w || (!dx && !dy)) continue;
            var q = yy * w + xx;
            if (mask[q] && !lab[q]) { lab[q] = n; stack[sp++] = q; }
          }
        }
      }
      area.push(a); sumX.push(sx);
    }
    return { lab: lab, n: n, area: area, sumX: sumX };
  }
  function fillHoles(mask, w, h) {
    var seen = new Uint8Array(w * h), stack = new Int32Array(w * h), sp = 0, x, y;
    function push(i) { if (!mask[i] && !seen[i]) { seen[i] = 1; stack[sp++] = i; } }
    for (x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (sp) {
      var p = stack[--sp]; x = p % w; y = (p - x) / w;
      if (x > 0) push(p - 1); if (x < w - 1) push(p + 1); if (y > 0) push(p - w); if (y < h - 1) push(p + w);
    }
    var out = new Uint8Array(w * h);
    for (var i = 0; i < w * h; i++) out[i] = mask[i] || !seen[i] ? 1 : 0;
    return out;
  }
  function polyMask(polys, w, h) {
    var c = canvas(w, h), x = ctx2d(c);
    x.fillStyle = '#fff';
    polys.forEach(function (pts) {
      x.beginPath(); pts.forEach(function (p, i) { if (i) x.lineTo(p[0], p[1]); else x.moveTo(p[0], p[1]); }); x.closePath(); x.fill();
    });
    var d = x.getImageData(0, 0, w, h).data, m = new Uint8Array(w * h);
    for (var i = 0; i < w * h; i++) m[i] = d[i * 4 + 3] > 127 ? 1 : 0;
    return m;
  }
  function smooth1d(arr, sigma) {
    var r = Math.ceil(sigma * 3), out = new Float64Array(arr.length), k = [], s = 0, i, j;
    for (j = -r; j <= r; j++) { k.push(Math.exp(-j * j / (2 * sigma * sigma))); s += k[k.length - 1]; }
    for (i = 0; i < arr.length; i++) {
      var acc = 0;
      for (j = -r; j <= r; j++) acc += arr[clamp(i + j, 0, arr.length - 1)] * k[j + r];
      out[i] = acc / s;
    }
    return out;
  }
  function loadImage(src, cors) {
    return new Promise(function (ok, fail) {
      var i = new Image();
      if (cors) i.crossOrigin = 'anonymous';
      i.onload = function () { ok(i); }; i.onerror = function () { fail(new Error('Bild nicht geladen: ' + src)); };
      i.src = src;
    });
  }
  function pixels(img) {
    var c = canvas(img.naturalWidth || img.width, img.naturalHeight || img.height), x = ctx2d(c);
    x.drawImage(img, 0, 0); return x.getImageData(0, 0, c.width, c.height).data;
  }
  function toBlob(c, type, q) { return new Promise(function (ok) { c.toBlob(ok, type, q); }); }
  // Bild auf den sichtbaren Teil (Alpha > 10) zuschneiden; gibt { canvas, x0, y0 }
  function cropAlpha(rgba, w, h) {
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      if (rgba[(y * w + x) * 4 + 3] > 10) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return null;
    var c = canvas(x1 - x0 + 1, y1 - y0 + 1), full = canvas(w, h);
    ctx2d(full).putImageData(new ImageData(rgba, w, h), 0, 0);
    ctx2d(c).drawImage(full, -x0, -y0);
    return { canvas: c, x0: x0, y0: y0 };
  }

  /* ---------- SAM-3-Masken (über den Bild-Dienst) ---------- */

  // Maske (data-URI, Graustufen-PNG in SAM_SIDE) → Uint8Array 0/1 in Fotogröße w × h
  // Maske eines Ausschnitts r (in Fotogröße W × H) → Uint8Array 0/1 für das ganze Foto
  function maskAusschnitt(uri, W, H, r) {
    return loadImage(uri).then(function (img) {
      var c = canvas(W, H), x = ctx2d(c);
      x.drawImage(img, r.x0, r.y0, r.w, r.h);
      var d = x.getImageData(0, 0, W, H).data, m = new Uint8Array(W * H);
      for (var i = 0; i < W * H; i++) m[i] = d[i * 4] > 127 && d[i * 4 + 3] > 127 ? 1 : 0;
      return m;
    });
  }
  function maskFromUri(uri, w, h) {
    return loadImage(uri).then(function (img) {
      var c = canvas(w, h), x = ctx2d(c);
      x.drawImage(img, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data, m = new Uint8Array(w * h);
      for (var i = 0; i < w * h; i++) m[i] = d[i * 4] > 127 ? 1 : 0;
      return m;
    });
  }
  function maskCanvas(m, w, h) {
    var c = canvas(w, h), x = ctx2d(c), im = x.createImageData(w, h);
    for (var i = 0; i < w * h; i++) im.data[i * 4 + 3] = m[i] ? 255 : 0;
    x.putImageData(im, 0, 0);
    return c;
  }
  // konvexe Hülle (Monotone Chain) der gesetzten Pixel in den Zeilen y0..y1; je Zeile reichen der linke und rechte Rand
  function huelle(m, w, y0, y1) {
    var pts = [], x, y;
    for (y = Math.max(0, y0); y <= y1; y += 2) {
      var l = -1, r = -1;
      for (x = 0; x < w; x++) if (m[y * w + x]) { if (l < 0) l = x; r = x; }
      if (l >= 0) { pts.push([l, y]); pts.push([r, y]); }
    }
    if (pts.length < 3) return [];
    pts.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
    function cross(o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); }
    var lo = [], up = [], i;
    for (i = 0; i < pts.length; i++) { while (lo.length >= 2 && cross(lo[lo.length - 2], lo[lo.length - 1], pts[i]) <= 0) lo.pop(); lo.push(pts[i]); }
    for (i = pts.length - 1; i >= 0; i--) { while (up.length >= 2 && cross(up[up.length - 2], up[up.length - 1], pts[i]) <= 0) up.pop(); up.push(pts[i]); }
    return lo.slice(0, -1).concat(up.slice(0, -1));
  }
  function overlap(a, b) { var s = 0; for (var i = 0; i < a.length; i++) if (a[i] && b[i]) s++; return s; }
  function flaeche(m) { var s = 0; for (var i = 0; i < m.length; i++) s += m[i]; return s; }
  // mehrere Gesichter (Pärchen, Gruppen): das größte
  function groesste(faces) { return faces.reduce(function (a, b) { return flaeche(b) > flaeche(a) ? b : a; }); }
  // alle Masken zu einem Begriff, nach Score sortiert
  function masksFor(ergebnisse, prompt) {
    var e = (ergebnisse || []).filter(function (r) { return r.prompt === prompt; })[0];
    if (!e || !e.masks || !e.masks.length) return [];
    return e.masks.map(function (m, i) { return { uri: m, score: (e.scores || [])[i] || 0 }; }).sort(function (a, b) { return b.score - a.score; });
  }
  // nur der Teil, um den es geht: Rechteck um die Maske plus Rand (spart Rechenzeit auf dem Handy)
  function region(m, W, H, rand, unten) {
    var x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) if (m[y * W + x]) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    if (x1 < 0) return null;
    var kh = y1 - y0 + 1, kw = x1 - x0 + 1;
    x0 = Math.max(0, Math.floor(x0 - rand * kw)); x1 = Math.min(W - 1, Math.ceil(x1 + rand * kw));
    y0 = Math.max(0, Math.floor(y0 - rand * kh)); y1 = Math.min(H - 1, Math.ceil(y1 + (rand + unten) * kh));
    return { x0: x0, y0: y0, w: x1 - x0 + 1, h: y1 - y0 + 1, kh: kh };
  }
  function sub(m, W, r) {
    var o = new Uint8Array(r.w * r.h);
    for (var y = 0; y < r.h; y++) o.set(m.subarray((r.y0 + y) * W + r.x0, (r.y0 + y) * W + r.x0 + r.w), y * r.w);
    return o;
  }

  /* ---------- Schnitt Mensch mit SAM-Masken (Regeln wie skripte/schnitt.py: --laenge 0.3 --start -0.1) ---------- */

  function schnittMensch(photo, cut, head, face, andere) {
    var W = photo.width, H = photo.height, i, x, y;
    // Lage aus der Gesichtsmaske: Schwerpunkt und Hauptachse (Stirn → Kinn)
    var n = 0, sx = 0, sy = 0, sxx = 0, syy = 0, sxy = 0;
    for (y = 0; y < H; y++) for (x = 0; x < W; x++) if (face[y * W + x]) { n++; sx += x; sy += y; sxx += x * x; syy += y * y; sxy += x * y; }
    if (n < 100) throw new Error('kein Gesicht');
    var mx = sx / n, my = sy / n, phi = 0.5 * Math.atan2(2 * (sxy / n - mx * my), (sxx / n - mx * mx) - (syy / n - my * my));
    var dx = Math.cos(phi), dy = Math.sin(phi);
    if (dy < 0) { dx = -dx; dy = -dy; }
    if (dy < 0.7) { dx = 0; dy = 1; }                     // Gesicht breiter als hoch: nicht drehen
    var tmin = 1e9, tmax = -1e9;
    for (y = 0; y < H; y++) for (x = 0; x < W; x++) if (face[y * W + x]) { var t = (x - mx) * dx + (y - my) * dy; if (t < tmin) tmin = t; if (t > tmax) tmax = t; }
    var fh0 = tmax - tmin;
    if (fh0 < MIN_FACE) throw new Error('Gesicht zu klein');
    var roll = Math.atan2(-dx, dy), c = [mx + dx * (tmin + tmax) / 2, my + dy * (tmin + tmax) / 2];
    // gerade drehen und Ausschnitt um das Gesicht (höchstens CROP_MAX px): 2,8 Gesichtshöhen breit und hoch, über dem
    // Gesicht 1 Gesichtshöhe Platz für Haare (bis 2026-10-28 2,3 und 0,53 – große Locken waren oben gerade abgeschnitten,
    // Joel: „teils wird das motiv jetzt nach oben abgeschnitten“), darunter 0,8 für Strähnen
    var ks = Math.min(1, CROP_MAX / (2.8 * fh0)), fhS = fh0 * ks, half = 1.4 * fhS, S = Math.round(2 * half);
    var cos = Math.cos(roll) * ks, sin = Math.sin(roll) * ks, oy = half + 0.1 * fhS;
    function draw(src) {
      var cv = canvas(S, S), xx = ctx2d(cv);
      xx.setTransform(cos, -sin, sin, cos, half - (cos * c[0] + sin * c[1]), oy - (-sin * c[0] + cos * c[1]));
      xx.drawImage(src, 0, 0);
      return ctx2d(cv).getImageData(0, 0, S, S).data;
    }
    var rgba = draw(photo), cd = draw(cut), hd = draw(maskCanvas(head, W, H)), fd = draw(maskCanvas(face, W, H));
    var N = S * S, alpha = new Float32Array(N), K = new Uint8Array(N), F = new Uint8Array(N), fremd = new Uint8Array(N);
    (andere || []).forEach(function (m) { var od = draw(maskCanvas(m, W, H)); for (var j = 0; j < N; j++) if (od[j * 4 + 3] > 127) fremd[j] = 1; });
    var top = S, chinY = -1, fx = 0, fn = 0;
    for (i = 0; i < N; i++) {
      alpha[i] = rgba[i * 4 + 3] ? cd[i * 4 + 3] / 255 : 0;
      K[i] = hd[i * 4 + 3] > 127 ? 1 : 0;
      if (fd[i * 4 + 3] > 127) { F[i] = 1; y = (i / S) | 0; if (y < top) top = y; if (y > chinY) chinY = y; fx += i % S; fn++; }
    }
    var fh = chinY - top, mid = [fx / fn, (top + chinY) / 2];
    var yS = chinY - 0.1 * fh, yE = chinY + 0.3 * fh, yU = top + 0.6 * fh;
    // bis Mundhöhe (yU): die konvexe Hülle um Kopf- und Gesichtsmaske – SAM lässt z. B. Brillengläser und Ohren aus
    // (2026-10-14: Augen hinter der Brille durchsichtig), die Hülle schließt sie ein, Kapuze und Kragen bleiben draußen.
    // Darunter Kopf und Gesicht bis zum Kinn, unter dem Kinn nur Haare, die spitz zulaufen. Weitere Gesichter fallen raus.
    var KF = new Uint8Array(N);
    for (i = 0; i < N; i++) KF[i] = K[i] || F[i] ? 1 : 0;
    var hp = huelle(KF, S, 0, Math.floor(yU)), oben = hp.length ? dilate(polyMask([hp], S, S), S, S, fh * 0.012) : KF;
    // Gesichtsmaske glätten (ruhige Kinnlinie wie bisher) und nur knapp erweitern, sonst kommen Kapuze und Kragen mit
    var Fs = blur(F, S, S, fh * 0.012);
    for (i = 0; i < N; i++) Fs[i] = Fs[i] > 0.5 ? 1 : 0;
    var Fd = dilate(Fs, S, S, fh * 0.006), weg = (andere && andere.length) ? dilate(fremd, S, S, fh * 0.1) : null, keep = new Uint8Array(N), low = new Uint8Array(N);
    // Halszone: unter dem Gesicht, in der Breite des Kinns (auf Höhe yS) bleibt nichts außer dem Gesicht selbst – sonst
    // bleibt z. B. ein Zopf vor dem Hals stehen und zwischen Kinn und Zopf entsteht ein Loch (Joels Testfoto, 2026-10-14)
    var ry = Math.max(0, Math.min(S - 1, Math.round(yS))), nL = S, nR = -1, unten = new Int32Array(S).fill(-1);
    for (x = 0; x < S; x++) if (Fd[ry * S + x]) { if (x < nL) nL = x; if (x > nR) nR = x; }
    for (x = nL; x <= nR; x++) for (y = S - 1; y >= 0; y--) if (Fd[y * S + x]) { unten[x] = y; break; }
    for (y = 0; y < S; y++) for (x = 0; x < S; x++) {
      i = y * S + x;
      if (weg && weg[i] && !Fd[i]) continue;
      if (!Fd[i] && x >= nL && x <= nR && unten[x] >= 0 && y > unten[x]) continue;
      if ((y < yU && oben[i]) || Fd[i] || (K[i] && y < yS)) keep[i] = 1;
      else if (K[i] && y >= yS) low[i] = 1;
    }
    // Strähnen ab yS: Innenkante folgt dem Haar, die Außenkante biegt nach innen, Spitze an der Halsseite bei yE
    var cc = components(low, S, S), r0 = Math.ceil(yS), r1 = Math.min(S - 1, Math.floor(yE)), rows = Math.max(0, r1 - r0 + 1);
    if (cc.n && rows) {
      var minX = new Int32Array((cc.n + 1) * rows).fill(S), maxX = new Int32Array((cc.n + 1) * rows).fill(-1);
      for (y = r0; y <= r1; y++) for (x = 0; x < S; x++) {
        var l = cc.lab[y * S + x];
        if (l) { var k = l * rows + (y - r0); if (x < minX[k]) minX[k] = x; if (x > maxX[k]) maxX[k] = x; }
      }
      var polys = [], minArea = Math.pow(fh * 0.03, 2), sg = Math.max(1, fh * 0.02);
      for (var l2 = 1; l2 <= cc.n; l2++) {
        if (cc.area[l2] < minArea) continue;
        var links = cc.sumX[l2] / cc.area[l2] < mid[0], ry = [], xi = [], wd = [];
        for (var j = 0; j < rows; j++) {
          var kk = l2 * rows + j;
          if (maxX[kk] < 0) continue;
          ry.push(r0 + j); xi.push(links ? maxX[kk] : minX[kk]); wd.push(maxX[kk] - minX[kk] + 1);
        }
        if (ry.length < 3) continue;
        var w0 = wd.slice(0, 3).sort(function (a, b) { return a - b; })[1];
        for (j = 0; j < ry.length; j++) {
          var t = clamp((ry[j] - yS) / (yE - yS), 0, 1);
          wd[j] = Math.min(wd[j], w0 * Math.pow(1 - Math.pow(t, 1.5), 0.8));
        }
        var xs = smooth1d(xi, sg), ws = smooth1d(wd, sg), outer = [], inner = [];
        for (j = 0; j < ry.length; j++) { outer.push([links ? xs[j] - ws[j] : xs[j] + ws[j], ry[j]]); inner.push([xs[j], ry[j]]); }
        polys.push(outer.concat(inner.reverse()));
      }
      if (polys.length) {
        var taper = polyMask(polys, S, S);
        for (i = 0; i < N; i++) if (taper[i] && K[i]) keep[i] = 1;
      }
    }
    // eingeschlossene Lücken füllen: SAM lässt z. B. Brillengläser aus der Gesichtsmaske aus (2026-10-14: Augen hinter
    // der Brille waren durchsichtig); was rundum von Kopf und Gesicht umschlossen ist, gehört zum Kopf
    keep = fillHoles(keep, S, S);
    var cutF = blur(dilate(keep, S, S, Math.max(1, fh * 0.01)), S, S, Math.max(1, fh * 0.008)), a = new Float32Array(N);
    for (i = 0; i < N; i++) a[i] = Math.min(1, alpha[i] * cutF[i]);
    // nur das Stück mit dem Gesicht; Kern deckend
    var seed = Math.round(mid[1]) * S + Math.round(mid[0]), m = new Uint8Array(N);
    for (i = 0; i < N; i++) m[i] = a[i] > 0.35 ? 1 : 0;
    var comp = components(m, S, S), lab = comp.lab[seed];
    if (lab) {
      for (i = 0; i < N; i++) m[i] = comp.lab[i] === lab ? 1 : 0;
      var cb = blur(dilate(m, S, S, 2), S, S, 1.5);
      for (i = 0; i < N; i++) a[i] *= cb[i];
    }
    for (i = 0; i < N; i++) m[i] = a[i] > 0.5 ? 1 : 0;
    var rEr = Math.max(3, Math.floor(fhS / 52)), core = blur(erode(fillHoles(m, S, S), S, S, rEr), S, S, rEr / 2);
    var out = new Uint8ClampedArray(rgba);
    for (i = 0; i < N; i++) out[i * 4 + 3] = Math.round(clamp(Math.max(a[i], core[i] * cutF[i]), 0, 1) * 255);
    var res = cropAlpha(out, S, S);
    if (!res) throw new Error('kein Kopf');
    return { canvas: res.canvas, face: { cx: mid[0] - res.x0, cy: mid[1] - res.y0, h: fh } };
  }

  /* ---------- Tier mit SAM-Kopfmaske: etwas Hals dazu, weiche Schnittkante ---------- */

  // opts (zum Vergleichen): hals = Anteil der Kopfhöhe unter der Maske, rand = wie weit über die Maske hinaus das Fell
  // vom Freisteller übernommen wird (Anteil der Kopfhöhe)
  function tierKopf(photo, cut, head, opts) {
    var hals = opts && opts.hals != null ? opts.hals : HALS, rand = opts && opts.rand != null ? opts.rand : RAND;
    var W = photo.width, r = region(head, W, photo.height, Math.max(0.08, rand + 0.05), hals + 0.05);
    if (!r) throw new Error('kein Tierkopf');
    var w = r.w, h = r.h, N = w * h, i, x, y, hm = sub(head, W, r);
    var pc = canvas(w, h), px = ctx2d(pc); px.drawImage(photo, -r.x0, -r.y0);
    var cc = canvas(w, h), cx2 = ctx2d(cc); cx2.drawImage(cut, -r.x0, -r.y0);
    var rgba = px.getImageData(0, 0, w, h).data, cd = cx2.getImageData(0, 0, w, h).data;
    // Kopfform nach unten verschoben dazunehmen: mehr Hals, gleiche runde Kinnlinie (laufende Summe je Spalte)
    var d = Math.round(hals * r.kh), ext = new Uint8Array(N);
    for (x = 0; x < w; x++) {
      var cnt = 0;
      for (y = 0; y < h; y++) {
        cnt += hm[y * w + x];
        if (y - d - 1 >= 0) cnt -= hm[(y - d - 1) * w + x];
        ext[y * w + x] = cnt > 0 ? 1 : 0;
      }
    }
    // außen entscheidet der Freisteller (Fell), unten eine weiche Schnittkante; Lücken in der Maske füllen
    ext = fillHoles(ext, w, h);
    var cutF = blur(dilate(ext, w, h, r.kh * rand), w, h, r.kh * 0.012), a = new Float32Array(N);
    for (i = 0; i < N; i++) a[i] = Math.min(1, cd[i * 4 + 3] / 255 * cutF[i]);
    // nur das Stück am Kopf, Kern deckend
    var m = new Uint8Array(N), sx = 0, sy = 0, n = 0;
    for (i = 0; i < N; i++) if (hm[i]) { sx += i % w; sy += (i / w) | 0; n++; }
    for (i = 0; i < N; i++) m[i] = a[i] > 0.35 ? 1 : 0;
    var comp = components(m, w, h), lab = comp.lab[Math.round(sy / n) * w + Math.round(sx / n)];
    if (!lab) { lab = 1; for (i = 2; i <= comp.n; i++) if (comp.area[i] > comp.area[lab]) lab = i; }
    for (i = 0; i < N; i++) m[i] = comp.lab[i] === lab ? 1 : 0;
    var cb = blur(dilate(m, w, h, 2), w, h, 1.5);
    for (i = 0; i < N; i++) { a[i] *= cb[i]; m[i] = a[i] > 0.5 ? 1 : 0; }
    var rr = Math.max(3, Math.floor(r.kh / 60)), core = blur(erode(fillHoles(m, w, h), w, h, rr), w, h, rr / 2);
    var out = new Uint8ClampedArray(rgba);
    for (i = 0; i < N; i++) out[i * 4 + 3] = Math.round(clamp(Math.max(a[i], core[i] * cutF[i]), 0, 1) * 255);
    var res = cropAlpha(out, w, h);
    if (!res) throw new Error('kein Kopf');
    return { canvas: res.canvas, face: null };
  }

  /* ---------- Wer ist auf dem Foto: Menschen, Tiere, mehrere (seit 2026-10-28) ---------- */

  function vereinen(ms, n) { var u = new Uint8Array(n); ms.forEach(function (m) { oder(u, m); }); return u; }
  function oder(a, b) { for (var i = 0; i < a.length; i++) if (b[i]) a[i] = 1; }
  function hoehe(m, W, H) { var b = region(m, W, H, 0, 0); return b ? b.kh : 0; }
  function mitte(m, W) { var sx = 0, sy = 0, n = 0; for (var i = 0; i < m.length; i++) if (m[i]) { sx += i % W; sy += (i / W) | 0; n++; } return [sx / n, sy / n]; }
  // Löcher füllen, nur im Rahmen um die Maske gerechnet
  function fuellen(m, W, H) {
    var b = region(m, W, H, 0, 0);
    if (!b) return m;
    var r = { x0: Math.max(0, b.x0 - 1), y0: Math.max(0, b.y0 - 1) };
    r.w = Math.min(W, b.x0 + b.w + 1) - r.x0; r.h = Math.min(H, b.y0 + b.h + 1) - r.y0;
    var f = fillHoles(sub(m, W, r), r.w, r.h), out = Uint8Array.from(m);
    for (var y = 0; y < r.h; y++) out.set(f.subarray(y * r.w, (y + 1) * r.w), (r.y0 + y) * W + r.x0);
    return out;
  }
  // berührt h die um d Pixel erweiterte Maske m? (nur im Rahmen um m gerechnet)
  function beruehrt(h, m, W, H, d) {
    var b = region(m, W, H, 0, 0), r = { x0: Math.max(0, Math.floor(b.x0 - d - 1)), y0: Math.max(0, Math.floor(b.y0 - d - 1)) };
    r.w = Math.min(W, Math.ceil(b.x0 + b.w + d + 1)) - r.x0; r.h = Math.min(H, Math.ceil(b.y0 + b.h + d + 1)) - r.y0;
    var g = dilate(sub(m, W, r), r.w, r.h, d);
    for (var y = 0; y < r.h; y++) for (var x = 0; x < r.w; x++) if (g[y * r.w + x] && h[(r.y0 + y) * W + r.x0 + x]) return true;
    return false;
  }
  // Masken, die zu mehr als der Hälfte auf der Fläche u liegen; doppelte (zur Hälfte deckungsgleich) nur einmal, die mit dem besseren Score
  function aufFlaeche(ms, u) { return ms.filter(function (m) { var a = flaeche(m); return a && overlap(m, u) > 0.5 * a; }); }
  // mittlere Deckkraft des Freistellers (RGBA-Daten d) auf der Maske, 0–1
  function deckung(m, d) { var n = 0, s = 0; for (var i = 0; i < m.length; i++) if (m[i]) { n++; s += d[i * 4 + 3]; } return n ? s / n / 255 : 0; }
  function einzeln(ms) {
    var out = [];
    ms.forEach(function (m) { if (!out.some(function (o) { return overlap(o, m) > 0.5 * Math.min(flaeche(o), flaeche(m)); })) out.push(m); });
    return out;
  }
  // Tiere, auf denen keine Kopfmaske liegt (Mädchen mit Hund: alle „head“-Masken beim Mädchen) und die groß genug sind,
  // um mitzuzählen: dafür fragt ausschneiden noch „animal head“. Kleine Tiere im Hintergrund kosten keine Anfrage.
  function ohneKopf(an, tk, hu, W, H) {
    var gross = Math.max.apply(null, [0].concat(hu.map(function (f) { return hoehe(f, W, H) * MENSCH_KOPF; }), tk.map(function (m) { return hoehe(m, W, H); })));
    var fl = Math.max.apply(null, [0].concat(an.map(flaeche)));
    return an.filter(function (a) {
      return flaeche(a) >= 0.15 * fl && hoehe(a, W, H) >= NEBEN * gross && !tk.some(function (m) { return overlap(m, a) > 0.5 * flaeche(m); });
    });
  }
  // Menschen: „human face“-Masken, die nicht auf einem Tier liegen; Tiere: ihre Kopfmasken. Seit 2026-10-29 nur, was der
  // Freisteller (RGBA-Daten ad) behält – eine am Bildrand angeschnittene Person kam sonst „zusammen“ mit in den Schnitt; behält er
  // nichts davon, alle wie bisher. Wer deutlich kleiner ist als der Größte, steht im Hintergrund und bleibt draußen (Pony mit
  // Person dahinter: nur das Pony). → [{ mensch, maske }]
  function motive(hu, tk, an, W, H, ad) {
    var tu = vereinen(an, W * H), alle = [];
    hu.forEach(function (f) { if (overlap(f, tu) < 0.5 * flaeche(f)) alle.push({ mensch: true, maske: f, groesse: hoehe(f, W, H) * MENSCH_KOPF }); });
    tk.forEach(function (m) { alle.push({ mensch: false, maske: m, groesse: hoehe(m, W, H) }); });
    var vorn = ad ? alle.filter(function (o) { return deckung(o.maske, ad) >= VORN; }) : [];
    if (vorn.length) alle = vorn;
    var gross = Math.max.apply(null, [0].concat(alle.map(function (o) { return o.groesse; })));
    return alle.filter(function (o) { return o.groesse >= NEBEN * gross; });
  }
  // Kopf gehört zum Gesicht: überdeckt es zur Hälfte oder umschließt es (Mitte des Gesichts im Rahmen des Kopfs – „head“ ist
  // bei Menschen manchmal nur das Haar, unten offen, das Gesicht liegt dann im Ring). Seit 2026-10-28 nur, wenn das Gesicht
  // mindestens ein Viertel so breit ist wie der Kopf: beim Pony lag das kleine Gesicht der Person dahinter im Rahmen des Ponykopfs.
  function gehoert(m, f, W, H) {
    if (overlap(m, f) > 0.5 * flaeche(f)) return true;
    var b = region(m, W, H, 0, 0), fb = region(f, W, H, 0, 0), c = mitte(f, W);
    return !!b && !!fb && fb.w >= 0.25 * b.w && c[0] >= b.x0 && c[0] < b.x0 + b.w && c[1] >= b.y0 && c[1] < b.y0 + b.h;
  }
  // Masken aus SAM → Kopf: { canvas, face } (einzeln) bzw. { canvas, face, gruppe } (mehrere)
  // hs „head“, fs „face“, hu „human face“, an „animal“, tk Tierköpfe (aus „head“ bzw. „animal head“)
  function schneiden(photo, cut, hs, fs, hu, an, tk, ad) {
    var W = photo.width, H = photo.height, mo = motive(hu, tk, an, W, H, ad);
    if (!mo.length) {   // weder Mensch noch Tier erkannt: wie bisher die beste Kopfmaske
      if (!hs.length) throw new Error('kein Kopf gefunden');
      return tierKopf(photo, cut, hs[0]);
    }
    var tu = vereinen(an, W * H), menschKoepfe = hs.filter(function (m) { return overlap(m, tu) <= 0.5 * flaeche(m); });
    if (mo.length > 1) return schnittGruppe(photo, cut, mo, menschKoepfe);
    if (!mo[0].mensch) return tierKopf(photo, cut, mo[0].maske);
    // Mensch: Gesicht = „face“-Masken auf diesem Menschengesicht (mit Bart), sonst die „human face“-Maske
    var hf = mo[0].maske, mf = fs.filter(function (f) { return overlap(f, hf) > 0.5 * flaeche(hf); });
    var face = mf.length ? groesste(mf) : hf, kopf = null;
    menschKoepfe.forEach(function (m) {   // alle Kopfmasken dieses Menschen zusammen, Löcher (Gesicht im Haarring) zu
      if (!gehoert(m, face, W, H)) return;
      if (!kopf) kopf = Uint8Array.from(m); else oder(kopf, m);
    });
    if (kopf) { oder(kopf, face); kopf = fillHoles(kopf, W, H); }
    else {
      // keine Kopfmaske dieses Menschen (auch nicht im Ausschnitt, siehe ausschneiden): eine, die das Gesicht wenigstens
      // anschneidet, sonst nur das Gesicht. Nie einen fremden Kopf – bis 2026-10-28 kam dann der nächstbeste dazu, und
      // die Hülle um Gesicht und fremden Kopf zog Hintergrund mit in den Schnitt.
      var best = menschKoepfe.reduce(function (a, m) { return !a || overlap(m, face) > overlap(a, face) ? m : a; }, null);
      kopf = best && overlap(best, face) > 0.1 * flaeche(face) ? best : Uint8Array.from(face);
    }
    // alle übrigen Gesichter (auch Tiergesichter) gelten als fremd und werden aus dem Schnitt genommen
    return schnittMensch(photo, cut, kopf, face, fs.concat(hu).filter(function (f) { return overlap(f, face) < 0.5 * flaeche(f); }));
  }

  // Mehrere zusammen, wie bisher von Hand gedruckt (Joel nach dem Vergleich mit „einzeln abwechselnd“: nur zusammen): ein
  // Motiv aus allen Köpfen mit etwas Schulter. Rahmen um alle Köpfe (Menschen: Gesicht mit Haar bis knapp unters Kinn, Tiere:
  // Kopfmaske), darin der Freisteller; unten 0,6 Gesichtshöhen unter dem tiefsten Kinn weich auslaufend, an den Seiten mit
  // 0,3 Gesichtshöhen Rand. Die Köpfe selbst bleiben ganz. face: Mitte und mittlere Höhe der Gesichter (placeHead).
  function schnittGruppe(photo, cut, mo, hs) {
    var W = photo.width, H = photo.height, N = W * H, ges = new Uint8Array(N), kinne = [], hoehen = [], gesichter = [], i, x, y;
    mo.forEach(function (o) {
      var b = region(o.maske, W, H, 0, 0), m = Uint8Array.from(o.maske), kinn;
      if (o.mensch) {
        // Haar dazu: Kopfmasken, die das Gesicht zu 30 % überdecken oder es berühren, aber nicht viel breiter sind (sonst zwei Köpfe)
        var fa = flaeche(o.maske);
        hs.forEach(function (h) {
          var hb = region(h, W, H, 0, 0);
          if (hb && hb.w < 2.5 * b.w && (overlap(h, o.maske) > 0.3 * fa || beruehrt(h, o.maske, W, H, Math.round(b.kh * 0.15)))) oder(m, h);
        });
        m = fuellen(m, W, H);
        kinn = Math.min(H, b.y0 + b.kh + Math.round(0.06 * b.kh));
        m.fill(0, kinn * W);
        gesichter.push({ cx: b.x0 + b.w / 2, cy: b.y0 + b.kh / 2, h: b.kh });
      } else {
        m = fuellen(m, W, H);
        kinn = b.y0 + b.kh;
        gesichter.push({ cx: b.x0 + b.w / 2, cy: b.y0 + b.kh / 2, h: b.kh * TIER_GESICHT });
      }
      kinne.push(kinn); hoehen.push(b.kh);
      oder(ges, m);
    });
    var fh = hoehen.reduce(function (a, b) { return a + b; }, 0) / hoehen.length;
    if (Math.max.apply(null, gesichter.map(function (g) { return g.h; })) < MIN_FACE) throw new Error('Gesicht zu klein');
    // oben 0,2 Gesichtshöhen Luft: „head“ lässt bei großen Locken manchmal Haar aus, dort entscheidet der Freisteller
    var g = region(ges, W, H, 0, 0), seite = 0.3 * fh, weich = 0.3 * fh;
    var r = { x0: Math.max(0, Math.floor(g.x0 - seite)), y0: Math.max(0, Math.floor(g.y0 - 0.2 * fh)) };
    var x1 = Math.min(W, Math.ceil(g.x0 + g.w + seite)), unten = Math.min(H, Math.round(Math.max.apply(null, kinne) + 0.6 * fh));
    r.w = x1 - r.x0; r.h = unten - r.y0;
    var w = r.w, h = r.h, kern = dilate(sub(ges, W, r), w, h, 4);
    var pc = canvas(w, h), px = ctx2d(pc); px.drawImage(photo, -r.x0, -r.y0);
    var cc = canvas(w, h), cx2 = ctx2d(cc); cx2.drawImage(cut, -r.x0, -r.y0);
    var out = px.getImageData(0, 0, w, h).data, cd = cx2.getImageData(0, 0, w, h).data;
    // weicher Rand: unten immer, oben und an den Seiten nur, wo der Rahmen im Foto endet (nicht am Bildrand)
    var randL = r.x0 > 0, randR = x1 < W, randO = r.y0 > 0, sw = Math.max(1, 0.1 * fh);
    for (y = 0; y < h; y++) {
      var fy = clamp((h - y) / weich, 0, 1) * (randO ? clamp(y / sw, 0, 1) : 1);
      for (x = 0; x < w; x++) {
        i = y * w + x;
        var f = fy * (randL ? clamp(x / sw, 0, 1) : 1) * (randR ? clamp((w - 1 - x) / sw, 0, 1) : 1), a = cd[i * 4 + 3] / 255;
        out[i * 4 + 3] = Math.round((kern[i] ? a : a * f) * 255);
      }
    }
    var res = cropAlpha(out, w, h);
    if (!res) throw new Error('kein Kopf');
    var mx = 0, my = 0;
    gesichter.forEach(function (q) { mx += q.cx / gesichter.length; my += q.cy / gesichter.length; });
    var gh = gesichter.reduce(function (a, q) { return a + q.h; }, 0) / gesichter.length;
    return { canvas: res.canvas, face: { cx: mx - r.x0 - res.x0, cy: my - r.y0 - res.y0, h: gh }, gruppe: mo.length };
  }

  /* ---------- Montage (wie testseite/index.html, compose) ---------- */

  // Art der Vorlage, einmal je Vorlage: Hoodie/Onesie (ohne 100 Gesichter und Logo) mit Faktor f für die Plätze (ZIEL) und
  // gesicht = Gesichtshöhe für Menschen auf Tiermotiven (in Einheiten von refBoxH, 0 = wie bisher nach der ganzen Höhe)
  function vorlagenArt(T) {
    if (T.art) return T.art;
    var t = T.json, name = t.name || '', typ = /onesie/.test(name) ? 'onesie' : /hoodie/.test(name) ? 'hoodie' : '';
    var a = { textil: !!typ && !/^(100-|logo-)/.test(name), f: 1, gesicht: 0 };
    if (a.textil) {
      var W = t.size[0], H = t.size[1], m = T.front, y0 = -1, y1 = -1, x, y;
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) if (m[(y * W + x) * 4] > 20) { if (y0 < 0) y0 = y; y1 = y; break; }
      var hs = t.slots.map(function (s) { return s.h; }).sort(function (p, q) { return p - q; }), n = hs.length;
      var hm = n % 2 ? hs[(n - 1) / 2] : (hs[n / 2 - 1] + hs[n / 2]) / 2, hoch = y1 - y0, ziel = ZIEL[typ];
      if (hoch > 0 && hm > 0) {
        a.f = Math.max(1, t.ref.faceH ? ziel.mensch * hoch / (t.ref.faceH * hm / t.refBoxH) : ziel.tier * hoch / hm);
        if (!t.ref.faceH) a.gesicht = ziel.mensch * hoch * t.refBoxH / (hm * a.f);
      }
    }
    return (T.art = a);
  }
  // Maßstab des Kopfs im Platz (Einheiten von refBoxH); gesicht: am Gesicht ausgerichtet statt an der Bildmitte
  function kopfMass(t, head, a) {
    var ref = t.ref, g = head.gruppe ? GRUPPE : 1;
    if (head.face && ref.faceH) return { k: ref.faceH * g / head.face.h, gesicht: true };
    if (head.face && a.gesicht) return { k: a.gesicht * g / head.face.h, gesicht: false };
    return { k: t.refBoxH / head.canvas.height * (head.drawn && ref.faceH ? GEZEICHNET : 1), gesicht: false };
  }
  function placeHead(x, t, head, a) {
    var ref = t.ref, im = head.canvas, m = kopfMass(t, head, a);
    if (m.gesicht) {
      x.translate(ref.faceDx, ref.faceDy); x.rotate(ref.tilt * Math.PI / 180); x.scale(m.k, m.k); x.translate(-head.face.cx, -head.face.cy);
    } else {
      x.rotate(ref.tilt * Math.PI / 180); x.scale(m.k, m.k); x.translate(-im.width / 2, -im.height / 2);
    }
    x.drawImage(im, 0, 0);
  }
  // Gruppen sind breiter als ein Kopf: Plätze weglassen, bis auf derselben Seite keine zwei Gruppen näher als 0,9 Breiten
  // beieinander liegen. Bei 2–3 Personen bleiben alle Plätze belegt, erst breite Gruppen (ab etwa 4 nebeneinander) lassen
  // Plätze frei, statt sich zu überdecken. Von 8 Durchgängen in gemischter Reihenfolge gilt der
  // mit den meisten Plätzen, bei Gleichstand der, bei dem freie Plätze am nächsten an belegten liegen (keine großen Lücken).
  // → Nummern der belegten Plätze
  function ausduennen(t, heads, a, name) {
    var kb = Math.max.apply(null, heads.map(function (h) { return h.canvas.width * kopfMass(t, h, a).k; }));
    var br = t.slots.map(function (s) { return kb * s.h * a.f / t.refBoxH * (s.sx || 1); });
    var zufall = startwert(name + '|platz|' + Math.round(kb)), best = null, bw = null;
    for (var v = 0; v < 8; v++) {
      var wahl = [];
      t.slots.map(function (s, i) { return [zufall(), i]; }).sort(function (p, q) { return p[0] - q[0]; }).forEach(function (z) {
        var i = z[1], s = t.slots[i];
        if (wahl.every(function (j) { var o = t.slots[j]; return o.layer !== s.layer || Math.hypot(o.cx - s.cx, o.cy - s.cy) >= 0.9 * Math.max(br[i], br[j]); })) wahl.push(i);
      });
      var luecke = 0;
      t.slots.forEach(function (s) { luecke += Math.min.apply(null, wahl.map(function (j) { return Math.hypot(t.slots[j].cx - s.cx, t.slots[j].cy - s.cy); })); });
      if (!best || wahl.length > best.length || (wahl.length === best.length && luecke < bw)) { best = wahl; bw = luecke; }
    }
    return best.sort(function (p, q) { return p - q; });
  }
  // Mehrere Köpfe auf die Plätze verteilen (seit 2026-10-27, Joel: „etwas zufälliger wäre besser“). Vorher abwechselnd von
  // oben nach unten: Bei Hoodies & Co. liegen die Plätze im Zickzack, so landete jeder Kopf auf einer Seite. Jetzt: Plätze
  // in gemischter Reihenfolge belegen, jeder bekommt den Kopf, der unter seinen drei nächsten schon belegten Nachbarn am
  // seltensten ist; jeder Kopf gleich oft (±1), auch pro Socke. Von 8 Versuchen gilt der am besten gemischte (nächster
  // Nachbar selten derselbe Kopf, links und rechts gleich verteilt). Startwert aus dem Vorlagennamen: gleiche Vorlage,
  // gleiche Verteilung, die Vorschau springt nicht. Gemessen an allen Vorlagen beider Shops: keine mehr mit deutlicher
  // Trennung nach Seiten (vorher 72 von 126 flachen bei GaS, alle 62 bei SuperHoodie, 12 Socken).
  var verteilt = {};
  function verteilung(slots, anzahl, name) {
    var key = name + '|' + anzahl + '|' + slots.length;
    if (!verteilt[key]) {
      var zufall = startwert(key), best = null, bm = Infinity;
      for (var v = 0; v < (anzahl > 1 ? 8 : 1); v++) {
        var w = verteilVersuch(slots, anzahl, zufall), m = anzahl > 1 ? mischung(slots, w, anzahl) : 0;
        if (m < bm) { best = w; bm = m; }
      }
      verteilt[key] = best;
    }
    return verteilt[key];
  }
  function startwert(text) {
    var h = 2166136261;
    for (var i = 0; i < text.length; i++) { h ^= text.charCodeAt(i); h = Math.imul(h, 16777619); }
    return function () {   // mulberry32
      h = (h + 0x6D2B79F5) | 0;
      var t = Math.imul(h ^ (h >>> 15), 1 | h);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function verteilVersuch(slots, anzahl, zufall) {
    var wahl = {}, zahl = [], max = Math.ceil(slots.length / anzahl), belegt = [], lage = {};
    for (var k = 0; k < anzahl; k++) zahl.push(0);
    slots.forEach(function (s) { var l = lage[s.layer] || (lage[s.layer] = { n: 0, zahl: zahl.slice() }); l.n++; });
    slots.map(function (s, i) { return [zufall(), i]; }).sort(function (a, b) { return a[0] - b[0]; }).forEach(function (x) {
      var i = x[1], s = slots[i], l = lage[s.layer];
      var nah = belegt.map(function (j) { return [Math.hypot(slots[j].cx - s.cx, slots[j].cy - s.cy), j]; })
        .sort(function (a, b) { return a[0] - b[0]; }).slice(0, 3);
      var best = 0, bw = null;
      for (var k = 0; k < anzahl; k++) {
        if (zahl[k] >= max || l.zahl[k] >= Math.ceil(l.n / anzahl)) continue;
        var w = [nah.filter(function (y) { return wahl[y[1]] === k; }).length, zahl[k], zufall()];
        if (!bw || w[0] < bw[0] || (w[0] === bw[0] && (w[1] < bw[1] || (w[1] === bw[1] && w[2] < bw[2])))) { best = k; bw = w; }
      }
      wahl[i] = best; zahl[best]++; l.zahl[best]++; belegt.push(i);
    });
    return wahl;
  }
  // 0 = gut gemischt: Anteil der Plätze, deren nächster Nachbar denselben Kopf hat, plus Unterschied links/rechts
  function mischung(slots, wahl, anzahl) {
    var gleich = 0, mx = 0, seiten = 0;
    slots.forEach(function (s) { mx += s.cx / slots.length; });
    slots.forEach(function (s, i) {
      var bd = Infinity, bj = -1;
      slots.forEach(function (o, j) { var d = Math.hypot(o.cx - s.cx, o.cy - s.cy); if (j !== i && d < bd) { bd = d; bj = j; } });
      if (bj > -1 && wahl[bj] === wahl[i]) gleich++;
    });
    for (var k = 0; k < anzahl; k++) {
      var l = [0, 0], r = [0, 0];
      slots.forEach(function (s, i) { var g = s.cx < mx ? l : r; g[1]++; if (wahl[i] === k) g[0]++; });
      seiten = Math.max(seiten, Math.abs((l[1] ? l[0] / l[1] : 0) - (r[1] ? r[0] / r[1] : 0)));
    }
    return gleich / slots.length + seiten;
  }

  function compose(T, heads, name) {
    var t = T.json, W = t.size[0], H = t.size[1], out = canvas(W, H), ox = ctx2d(out);
    ox.drawImage(T.leer, 0, 0, W, H);
    var od = ox.getImageData(0, 0, W, H), o = od.data, off = canvas(W, H), x = ctx2d(off), sm = t.shadeMax / 255, art = vorlagenArt(T);
    x.imageSmoothingQuality = 'high';
    var nr = heads.some(function (h) { return h.gruppe; }) ? ausduennen(t, heads, art, name) : null;
    var slots = nr ? nr.map(function (i) { return t.slots[i]; }) : t.slots;
    var idx = verteilung(slots, heads.length, name + (nr ? '|' + nr.join('.') : '')), wahl = {};
    slots.forEach(function (s, n) { wahl[n] = heads[idx[n]]; });
    ['back', 'front'].forEach(function (layer) {
      x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, W, H);
      slots.forEach(function (s, n) {
        if (s.layer !== layer) return;
        var sc = s.h * art.f / t.refBoxH;
        x.setTransform(1, 0, 0, 1, 0, 0);
        x.translate(s.cx, s.cy); x.rotate(s.angle * Math.PI / 180); x.scale(sc * s.sx, sc);
        placeHead(x, t, wahl[n], art);
      });
      var hp = x.getImageData(0, 0, W, H).data, mask = layer === 'front' ? T.front : T.back;
      for (var i = 0; i < hp.length; i += 4) {
        if (!hp[i + 3] || !mask[i]) continue;
        var a = hp[i + 3] / 255 * mask[i] / 255, sh = T.shade[i] * sm;
        o[i] = o[i] * (1 - a) + Math.min(255, hp[i] * sh) * a;
        o[i + 1] = o[i + 1] * (1 - a) + Math.min(255, hp[i + 1] * sh) * a;
        o[i + 2] = o[i + 2] * (1 - a) + Math.min(255, hp[i + 2] * sh) * a;
      }
    });
    ox.putImageData(od, 0, 0);
    return out;
  }

  /* ---------- Logo-Produkte (seit 2026-10-15) ---------- */

  // Statt eines Kopfes ein weißer Kreis mit dünnem Rand und dem Logo darin, wie „Dein Logo“ im Produktfoto. Die Plätze
  // (skripte/kreise.py) haben h = Durchmesser samt Rand, ref ohne Gesicht: placeHead zieht den Kreis auf die Höhe h.
  // Kein Ausschneiden, kein Bild-Dienst. Weißer bzw. durchsichtiger Rand um das Logo fällt weg, die Diagonale des Logos
  // nimmt LOGO_DIAG des Durchmessers ein (bleibt so im Kreis, ob quadratisch oder breit).
  var KREIS = 400, KREIS_RAND = 0.022, LOGO_DIAG = 0.84, LOGO_SEITE = 800;
  function logoZuschnitt(img) {
    var iw = img.naturalWidth || img.width || 512, ih = img.naturalHeight || img.height || 512;   // SVG ohne Größe
    var s = Math.min(1, LOGO_SEITE / Math.max(iw, ih)), w = Math.max(1, Math.round(iw * s)), h = Math.max(1, Math.round(ih * s));
    var c = canvas(w, h), x = ctx2d(c);
    x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) for (var xx = 0; xx < w; xx++) {
      var i = (y * w + xx) * 4;
      if (d[i + 3] > 16 && Math.min(d[i], d[i + 1], d[i + 2]) < 240) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return c;   // nur Weiß: ganzes Bild
    var m = Math.round(Math.max(x1 - x0, y1 - y0) * 0.02);
    x0 = Math.max(0, x0 - m); y0 = Math.max(0, y0 - m); x1 = Math.min(w - 1, x1 + m); y1 = Math.min(h - 1, y1 + m);
    var out = canvas(x1 - x0 + 1, y1 - y0 + 1);
    ctx2d(out).drawImage(c, -x0, -y0);
    return out;
  }
  function logoKreis(img) {
    var c = canvas(KREIS, KREIS), x = ctx2d(c), r = KREIS / 2, lw = KREIS * KREIS_RAND, b = logoZuschnitt(img);
    x.fillStyle = '#FFFFFF'; x.beginPath(); x.arc(r, r, r, 0, 2 * Math.PI); x.fill();
    var k = LOGO_DIAG * KREIS / Math.hypot(b.width, b.height);
    x.imageSmoothingQuality = 'high';
    x.drawImage(b, r - b.width * k / 2, r - b.height * k / 2, b.width * k, b.height * k);
    x.strokeStyle = '#3A3A3C'; x.lineWidth = lw; x.beginPath(); x.arc(r, r, r - lw / 2, 0, 2 * Math.PI); x.stroke();
    return c;
  }

  /* ---------- Erstes Bild mit Polaroid ---------- */

  // Jede Vorlage hat ein erstes Bild im Aufbau des Werbebilds (skripte/buehne.py): buehne.jpg mit Beispielköpfen und
  // Beispielfoto, leer.jpg mit leerem Fotofeld. vorlage.json → polaroid: Mitte, Größe und Drehung des Fotofelds.
  var FOKUS = 0.35;         // Foto im Polaroid: so weit oben bleibt es beim Beschneiden (0 oben, 0,5 Mitte), Gesichter sitzen meist oben

  function feld(x, f, p) {
    var iw = f.bild.width, ih = f.bild.height, s = (f.contain ? Math.min : Math.max)(p.w / iw, p.h / ih) * (f.rand || 1), w = iw * s, h = ih * s;
    x.save();
    x.translate(p.cx, p.cy); x.rotate(p.winkel * Math.PI / 180);
    x.beginPath(); x.rect(-p.w / 2, -p.h / 2, p.w, p.h); x.clip();
    x.fillStyle = '#FFFFFF'; x.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
    x.drawImage(f.bild, -w / 2, f.contain ? -h / 2 : -p.h / 2 - (h - p.h) * FOKUS, w, h);
    x.restore();
  }
  function karte(x, p) {
    var m = p.w * 0.07, unten = p.w * 0.2;
    x.save();
    x.translate(p.cx, p.cy); x.rotate(p.winkel * Math.PI / 180);
    x.shadowColor = 'rgba(20, 21, 26, .28)'; x.shadowBlur = 14; x.shadowOffsetY = 4;
    x.fillStyle = '#FFFFFF'; x.fillRect(-p.w / 2 - m, -p.h / 2 - m, p.w + 2 * m, p.h + m + unten);
    x.restore();
  }
  // Fotos ins Polaroid: das erste ins Fotofeld, ein zweites als kleinere Karte rechts unten darüber (auf einer Kopie von grund)
  function polaroid(grund, t, fotos) {
    var c = canvas(t.size[0], t.size[1]), x = ctx2d(c), p = t.polaroid;
    x.drawImage(grund, 0, 0, c.width, c.height);
    if (fotos[0]) feld(x, fotos[0], p);
    if (fotos[1]) {
      var q = { cx: p.cx + 90, cy: p.cy + 100, w: p.w * 0.62, h: p.h * 0.62, winkel: 6 };
      karte(x, q); feld(x, fotos[1], q);
    }
    return c;
  }
  function verkleinern(img) {
    var s = Math.min(1, 640 / Math.max(img.naturalWidth, img.naturalHeight)), c = canvas(Math.round(img.naturalWidth * s), Math.round(img.naturalHeight * s));
    ctx2d(c).drawImage(img, 0, 0, c.width, c.height);
    return c;
  }

  /* ---------- Anbindung an den Konfigurator (sh-configurator.js) ---------- */

  // Das erste Bild (und sein Vorschaubild) kommt von hier, sobald es für Produkt und Farbe eine Vorlage gibt:
  // ohne Foto buehne.jpg, nach dem Hochladen sofort das eigene Foto im Polaroid (Socke noch mit Beispielköpfen),
  // dann die Socke mit den eigenen Köpfen. Klappt das Ausschneiden nicht, bleibt alles wie ohne Vorschau
  // (Produktfoto, eigenes Foto als Polaroid darüber).
  function SockPreview(cfg) {
    this.cfg = cfg;
    this.base = String(cfg.config.aiEndpoint || '').replace(/\/?$/, '/') + 'vorlagen/';
    this.cuts = typeof WeakMap === 'function' ? new WeakMap() : null;   // Foto → Kopf
    this.drawn = {};      // URL des gezeichneten Kopfs → Kopf
    this.tpls = {};       // Vorlage → Promise
    this.stages = {};     // Vorlage → Promise { bild: buehne.jpg, json }
    this.kleine = {};     // Bild im Polaroid → Promise (verkleinert)
    this.seq = 0;
    this.lauf = 0;
    this.stage = null;    // { tpl, bilder, key, url, busy, eigen }: das aktuelle erste Bild
    this.montage = null;  // { tpl, canvas }: Socke mit den zuletzt fertigen eigenen Köpfen, ohne Polaroid
    this.pending = '';    // key, der gerade entsteht
    this.aus = '';        // Fotos, für die es keine Vorschau gibt (basis())
    this.kontrolle = false;   // Vorschau-Kontrolle an („kontrolle“ in index.json), siehe melden()
    this.gemeldet = {};
    var self = this;
    this.index = null;
    this.v = '';          // ?v=<stand aus index.json>: neue Vorlagen kommen trotz Browser-Cache (Vorlagen 1 Tag, index.json immer frisch)
    fetch(this.base + 'index.json', { cache: 'no-cache' }).then(function (r) { return r.json(); }).then(function (j) {
      self.v = j.stand ? '?v=' + encodeURIComponent(j.stand) : '';
      self.kontrolle = j.kontrolle === true;
      self.index = j.produkte || {};
      if (self.index[cfg.config.handle]) self.refresh();
    }).catch(function () {});
  }

  // Vorlage der gewählten Farbe ('' ohne)
  SockPreview.prototype.tplName = function () {
    var cfg = this.cfg, entry = this.index && this.index[cfg.config.handle];
    if (!entry) return '';
    return entry[cfg.config.colourIndex > -1 ? cfg.options[cfg.config.colourIndex] : ''] || '';
  };
  // Bilder im Polaroid: die eigenen Fotos (Logos ganz, nicht beschnitten); im gezeichneten Stil das fertig gezeichnete Bild,
  // solange es gezeichnet wird das Foto (Joel 2026-10-15: „wenn das foto oben rechts dann auch die cartoon vorschau ist“);
  // ohne Foto im gezeichneten Stil dessen Beispiel, sonst keins (Beispielfoto der Bühne)
  SockPreview.prototype.bilder = function () {
    var cfg = this.cfg, ganz = !!cfg.config.logo;
    var eigen = function (n) {
      var a = cfg.isCartoon() && cfg.art[cfg.style] && cfg.art[cfg.style][n];
      if (a && a.status === 'done' && a.url) return { src: a.url, contain: true };
      return ganz ? { src: cfg.urls[n], contain: true, rand: 0.82 } : { src: cfg.urls[n] };
    };
    if (cfg.files[1]) return [eigen(1)].concat(cfg.needsTwo() && cfg.files[2] && cfg.previewable[2] ? [eigen(2)] : []);
    var ex = cfg.isCartoon() ? cfg.$('[data-shp-style-img="' + cfg.style + '"]') : null;
    var src = ex ? (ex.getAttribute('data-example') || ex.getAttribute('src')) : '';
    return src ? [{ src: src, contain: true }] : [];
  };
  function bilderKey(b) { return b.map(function (f) { return f.src; }).join(' '); }
  SockPreview.prototype.basis = function () {
    var cfg = this.cfg;
    return [cfg.style, cfg.urls[1], cfg.needsTwo() ? cfg.urls[2] : ''].join('|');
  };

  SockPreview.prototype.ownsStage = function () {
    var cfg = this.cfg;
    return !!this.tplName() && !(cfg.files[1] && (!cfg.previewable[1] || this.aus === this.basis()));
  };
  SockPreview.prototype.stageSrc = function () {
    if (!this.ownsStage()) return null;
    var s = this.stage;
    // Gleiche Bilder im Polaroid oder weiter eigene Fotos: das letzte erste Bild, bis das neue fertig ist (auch bei neuer Farbe)
    if (s && (s.bilder === bilderKey(this.bilder()) || (s.eigen && this.cfg.files[1]))) return s.url;
    return this.datei(this.tplName(), 'buehne.jpg');
  };
  SockPreview.prototype.busy = function () {
    var s = this.stage;
    return !!(this.cfg.files[1] && this.ownsStage() && (!s || s.busy || s.bilder !== bilderKey(this.bilder())));
  };

  SockPreview.prototype.refresh = function () {
    var self = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () { self.run(); }, 60);
  };

  SockPreview.prototype.run = function () {
    var self = this, cfg = this.cfg, tpl = this.tplName();
    if (!tpl || (cfg.files[1] && !cfg.previewable[1])) return;
    var bilder = this.bilder(), bkey = bilderKey(bilder), heads = null, busy = false;
    if (!cfg.files[1]) this.montage = null;
    if (cfg.files[1]) {
      var faces = cfg.needsTwo() && cfg.files[2] ? [1, 2] : [1];
      heads = faces.map(function (n) { return self.headFor(n, tpl); });
      if (heads.some(function (h) { return h.status === 'none' || h.status === 'error'; })) {
        this.lauf++; this.pending = ''; this.aus = this.basis(); cfg.renderStage(); return;
      }
      busy = heads.some(function (h) { return h.status === 'busy'; });
    }
    this.aus = '';
    var s = this.stage;
    // Neuer Stil wird noch gezeichnet: die Socke von eben bleibt stehen
    if (busy && s && s.tpl === tpl && s.bilder === bkey) { s.busy = true; cfg.renderStage(); return; }
    var key = tpl + '|' + bkey + '|' + (busy ? 'warten' : heads ? heads.map(function (h) { return h.id; }).join(',') : 'beispiel');
    if ((s && s.key === key) || this.pending === key) return;
    if (!heads && !bilder.length) { this.setStage({ tpl: tpl, bilder: bkey, key: key, url: this.datei(tpl, 'buehne.jpg') }); return; }
    var my = ++this.lauf;
    this.pending = key;
    var bild = heads && !busy
      ? Promise.all([this.template(tpl), this.fotos(bilder)]).then(function (r) {
        var m = compose(r[0], heads.map(function (h) { return h.head; }), tpl);
        if (my === self.lauf) self.montage = { tpl: tpl, canvas: m };
        return polaroid(m, r[0].json, r[1]);
      })
      // Zwischenstand: eigene Fotos im Polaroid, auf der Socke die zuletzt fertigen eigenen Köpfe oder die Beispielköpfe
      : Promise.all([this.buehne(tpl), this.fotos(bilder)]).then(function (r) {
        var m = self.montage;
        return polaroid(heads && m && m.tpl === tpl ? m.canvas : r[0].bild, r[0].json, r[1]);
      });
    bild.then(function (c) {
      if (heads && !busy && my === self.lauf) self.melden(key, c);
      return toBlob(c, 'image/jpeg', 0.9);
    }).then(function (blob) {
      if (my !== self.lauf) return;
      self.setStage({ tpl: tpl, bilder: bkey, key: key, url: URL.createObjectURL(blob), busy: busy, eigen: !!heads });
    }).catch(function (e) {
      if (my !== self.lauf) return;
      if (window.console) console.info('Socken-Vorschau:', e && e.message);
      if (heads) self.melden(key, null, e && e.message);
      self.pending = '';
      if (heads) { self.aus = self.basis(); cfg.renderStage(); }
      else self.setStage({ tpl: tpl, bilder: bkey, key: key, url: self.datei(tpl, 'buehne.jpg') });   // Beispiel ohne Stil-Bild
    });
  };

  // Vorschau-Kontrolle (seit 2026-10-27, an/aus mit „kontrolle“ in index.json des Bild-Dienstes): das fertige erste Bild
  // verkleinert an den Bild-Dienst (art=kontrolle), bei Fehlern nur die Meldung. Jedes Bild nur einmal, erst 1,5 s nach
  // der Anzeige; klappt es nicht, merkt der Kunde nichts. Fotos und KI-Bilder legt der Bild-Dienst selbst ab.
  SockPreview.prototype.melden = function (key, c, fehler) {
    if (!this.kontrolle || this.gemeldet[key]) return;
    this.gemeldet[key] = true;
    var cfg = this.cfg, k = c ? klein(c, 900) : null;
    var info = JSON.stringify({
      produkt: cfg.config.handle, farbe: cfg.config.colourIndex > -1 ? cfg.options[cfg.config.colourIndex] : '', vorlage: this.tplName(),
      stil: cfg.config.logo ? 'logo' : cfg.style, status: k ? 'ok' : 'fehler', fehler: fehler ? String(fehler).slice(0, 150) : ''
    });
    setTimeout(function () {
      (k ? toBlob(k, 'image/jpeg', 0.8) : Promise.resolve(null)).then(function (blob) {
        var fd = new FormData();
        fd.append('info', info);
        if (blob) fd.append('bild', blob, 'vorschau.jpg');
        return fetch(cfg.config.aiEndpoint + '?art=kontrolle', { method: 'POST', body: fd });
      }).catch(function () {});
    }, 1500);
  };
  function klein(c, max) {
    var s = Math.min(1, max / Math.max(c.width, c.height));
    if (s === 1) return c;
    var k = canvas(Math.round(c.width * s), Math.round(c.height * s));
    ctx2d(k).drawImage(c, 0, 0, k.width, k.height);
    return k;
  }

  SockPreview.prototype.setStage = function (s) {
    var old = this.stage;
    this.stage = s; this.pending = '';
    this.cfg.renderStage();
    if (old && old.url !== s.url && old.url.indexOf('blob:') === 0) setTimeout(function () { URL.revokeObjectURL(old.url); }, 1000);
  };

  SockPreview.prototype.datei = function (name, f) { return this.base + name + '/' + f + this.v; };
  SockPreview.prototype.buehne = function (name) {
    var st = this.stages;
    if (!st[name]) {
      st[name] = Promise.all([loadImage(this.datei(name, 'buehne.jpg'), true), fetch(this.datei(name, 'vorlage.json')).then(function (r) { return r.json(); })])
        .then(function (a) { return { bild: a[0], json: a[1] }; });
      st[name].catch(function () { delete st[name]; });
    }
    return st[name];
  };

  // Bilder fürs Polaroid, verkleinert; behält nur die aktuellen
  SockPreview.prototype.fotos = function (bilder) {
    var alt = this.kleine, neu = {};
    this.kleine = neu;
    return Promise.all(bilder.map(function (f) {
      var p = neu[f.src] = alt[f.src] || loadImage(f.src, !/^blob:/.test(f.src)).then(verkleinern);
      return p.then(function (bild) { return { bild: bild, contain: f.contain, rand: f.rand }; });
    }));
  };

  // Kopf für Foto n im gewählten Stil: { status: none|busy|done|error, id, head }
  SockPreview.prototype.headFor = function (n, tplName) {
    var self = this, cfg = this.cfg;
    if (cfg.config.logo) {   // Logo-Produkte: Logo im weißen Kreis, ohne Bild-Dienst
      var lf = cfg.files[n];
      if (!lf || !cfg.previewable[n] || !this.cuts) return { status: 'none' };
      var le = this.cuts.get(lf);
      if (!le) {
        le = { status: 'busy', id: 'l' + (++this.seq) };
        this.cuts.set(lf, le);
        loadImage(cfg.urls[n]).then(function (img) { le.head = { canvas: logoKreis(img), face: null }; le.status = 'done'; }, function (err) {
          le.status = 'error';
          if (window.console) console.info('Socken-Vorschau, Logo:', err && err.message);
        }).then(function () { self.refresh(); });
      }
      return le;
    }
    if (cfg.style === 'foto') {
      var file = cfg.files[n];
      if (!file || !cfg.previewable[n] || !this.cuts) return { status: 'none' };
      var e = this.cuts.get(file);
      if (!e) {
        e = { status: 'busy', id: 'f' + (++this.seq) };
        this.cuts.set(file, e);
        this.ausschneiden(file, tplName).then(function (head) { e.head = head; e.status = 'done'; }, function (err) {
          e.status = 'error';
          if (window.console) console.info('Socken-Vorschau, Ausschneiden:', err && err.message);
          self.melden(e.id, null, 'Ausschneiden: ' + (err && err.message));
        }).then(function () { self.refresh(); });
      }
      return e;
    }
    var a = cfg.art[cfg.style] && cfg.art[cfg.style][n];
    if (!a || a.status === 'none' || a.status === 'error') return { status: a && a.status === 'error' ? 'error' : 'none' };
    if (a.status === 'busy') return { status: 'busy' };
    var d = this.drawn[a.url];
    if (!d) {
      d = this.drawn[a.url] = { status: 'busy', id: 'd' + (++this.seq) };
      loadImage(a.url).then(function (img) {
        var c = canvas(img.naturalWidth, img.naturalHeight), x = ctx2d(c);
        x.drawImage(img, 0, 0);
        var r = cropAlpha(x.getImageData(0, 0, c.width, c.height).data, c.width, c.height);
        if (!r) throw new Error('leer');
        d.head = { canvas: r.canvas, face: null, drawn: true }; d.status = 'done';
      }).catch(function () { d.status = 'error'; }).then(function () { self.refresh(); });
    }
    return d;
  };

  // Echtes Foto → ausgeschnittener Kopf. Freistellen und SAM laufen parallel.
  // Wer auf dem Foto ist, entscheidet schneiden(): Menschen über „human face“ (2026-10-14), Tiere seit 2026-10-28 über
  // „animal“ – vorher galt jeder Kopf ohne Menschengesicht als Tier und hatte auf Tiermotiven Vorrang. Einer: wie bisher
  // Mensch- bzw. Tierschnitt, mehrere: zusammen (schnittGruppe), egal ob Gesichts- oder Tiermotiv.
  SockPreview.prototype.ausschneiden = function (file, tplName) {
    var self = this, photo, image;
    return Promise.all([
      typeof createImageBitmap === 'function' ? createImageBitmap(file) : Promise.reject(new Error('Browser zu alt')),
      this.template(tplName)
    ]).then(function (r) {
      var bmp = r[0];
      var s = Math.min(1, MAX_SIDE / Math.max(bmp.width, bmp.height));
      photo = canvas(Math.round(bmp.width * s), Math.round(bmp.height * s));
      ctx2d(photo).drawImage(bmp, 0, 0, photo.width, photo.height);
      var s2 = Math.min(1, SAM_SIDE / Math.max(bmp.width, bmp.height)), small = canvas(Math.round(bmp.width * s2), Math.round(bmp.height * s2));
      ctx2d(small).drawImage(bmp, 0, 0, small.width, small.height);
      image = small.toDataURL('image/jpeg', 0.9);
      if (bmp.close) bmp.close();
      return Promise.all([self.freistellen(photo), self.sam(image, ['head', 'face', 'human face', 'animal'])]);
    }).then(function (r) {
      var cut = r[0], erg = r[1], W = photo.width, H = photo.height;
      var listen = ['head', 'face', 'human face', 'animal'].map(function (p) { return masksFor(erg, p); });
      if (!listen[0].length && !listen[2].length && !listen[3].length) throw new Error('kein Kopf gefunden');
      function masken(l) { return Promise.all(l.map(function (f) { return maskFromUri(f.uri, W, H); })); }
      return Promise.all(listen.map(masken)).then(function (ms) {
        // Tiere nur, wo der Freisteller etwas behält: gemalte Tiere im Hintergrund (Hello Kitty an einem Kinderkarussell,
        // 2026-10-28) hält „animal“ auch für Tiere, sonst kamen sie als zweites Motiv „zusammen“ mit dem Kind in den Schnitt
        var ad = ctx2d(cut).getImageData(0, 0, W, H).data, an = ms[3].filter(function (m) { return deckung(m, ad) >= VORN; });
        var hs = ms[0], fs = ms[1], hu = ms[2], tk = einzeln(aufFlaeche(hs, vereinen(an, W * H))), offen = ohneKopf(an, tk, hu, W, H);
        // Tier ohne Kopfmaske: „animal head“ nachfragen; klappt das nicht, bleibt es bei den Köpfen von eben
        return (offen.length ? self.sam(image, ['animal head']).then(function (e) { return masken(masksFor(e, 'animal head')); }, function () { return []; }).then(function (ah) {
          tk = einzeln(tk.concat(aufFlaeche(ah, vereinen(offen, W * H))));
        }) : Promise.resolve()).then(function () {
          // Mensch ohne eigene Kopfmaske: SAM liefert je Begriff höchstens 3 Masken, auf Fotos mit Leuten im Hintergrund
          // können das alles fremde Köpfe sein (2026-10-28, Kundin im Café: nur das Gesicht, Haare oben gerade abgeschnitten).
          // Dann „head“ noch einmal auf einem Ausschnitt um diese Gesichter; klappt das nicht, bleibt es beim Gesicht.
          var ohne = motive(hu, tk, an, W, H, ad).filter(function (o) { return o.mensch && !hs.some(function (h) { return gehoert(h, o.maske, W, H); }); });
          if (!ohne.length) return;
          return self.kopfImAusschnitt(photo, ohne.map(function (o) { return o.maske; })).then(function (neu) { hs = hs.concat(neu); }, function () {});
        }).then(function () { return schneiden(photo, cut, hs, fs, hu, an, tk, ad); });
      });
    });
  };
  // „head“ auf einem Ausschnitt um die Gesichter (1,2 Gesichtshöhen darüber, 0,9 daneben, 0,8 darunter); nur Köpfe, die zu
  // einem dieser Gesichter gehören
  SockPreview.prototype.kopfImAusschnitt = function (photo, faces) {
    var W = photo.width, H = photo.height, b = region(vereinen(faces, W * H), W, H, 0, 0);
    var fh = Math.max.apply(null, faces.map(function (f) { return hoehe(f, W, H); }));
    var r = { x0: Math.max(0, Math.floor(b.x0 - 0.9 * fh)), y0: Math.max(0, Math.floor(b.y0 - 1.2 * fh)) };
    r.w = Math.min(W, Math.ceil(b.x0 + b.w + 0.9 * fh)) - r.x0; r.h = Math.min(H, Math.ceil(b.y0 + b.kh + 0.8 * fh)) - r.y0;
    var s = Math.min(1, SAM_SIDE / Math.max(r.w, r.h)), c = canvas(Math.round(r.w * s), Math.round(r.h * s));
    ctx2d(c).drawImage(photo, r.x0, r.y0, r.w, r.h, 0, 0, c.width, c.height);
    return this.sam(c.toDataURL('image/jpeg', 0.9), ['head']).then(function (e) {
      return Promise.all(masksFor(e, 'head').map(function (m) { return maskAusschnitt(m.uri, W, H, r); }));
    }).then(function (ms) {
      return ms.filter(function (m) { return flaeche(m) && faces.some(function (f) { return gehoert(m, f, W, H); }); });
    });
  };

  SockPreview.prototype.freistellen = function (photo) {
    var self = this;
    return toBlob(photo, 'image/jpeg', 0.92).then(function (b) { return self.call('freistellen', b); }).then(function (res) {
      if (!res.ok) throw new Error('Freistellen ' + res.status);
      return res.blob();
    }).then(function (blob) { return loadImage(URL.createObjectURL(blob)); }).then(function (img) {
      var cut = canvas(photo.width, photo.height);
      ctx2d(cut).drawImage(img, 0, 0, photo.width, photo.height);
      URL.revokeObjectURL(img.src);
      return cut;
    });
  };

  // Mehr als SAM_JE_ANFRAGE Begriffe: parallel in mehreren Anfragen. Die erste muss klappen, fehlt eine weitere, fehlen nur
  // deren Masken (dann ohne „animal“ wie vor 2026-10-28).
  SockPreview.prototype.sam = function (image, prompts) {
    var self = this, teile = [];
    for (var i = 0; i < prompts.length; i += SAM_JE_ANFRAGE) teile.push(prompts.slice(i, i + SAM_JE_ANFRAGE));
    return Promise.all(teile.map(function (p, n) {
      var anfrage = self.samAnfrage(image, p);
      return n ? anfrage.catch(function () { return []; }) : anfrage;
    })).then(function (r) { return [].concat.apply([], r); });
  };
  SockPreview.prototype.samAnfrage = function (image, prompts) {
    var cfg = this.cfg;
    return cfg.turnstileToken().then(function (token) {
      return fetch(cfg.config.aiEndpoint + '?art=sam', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: image, prompts: prompts, turnstile: token || undefined })
      });
    }).then(function (res) {
      return res.json().then(function (j) {
        if (!res.ok || !j.ergebnisse) throw new Error('SAM ' + res.status);
        return j.ergebnisse;
      });
    });
  };

  SockPreview.prototype.call = function (art, blob) {
    var cfg = this.cfg;
    return cfg.turnstileToken().then(function (token) {
      var fd = new FormData();
      fd.append('photo', blob, 'photo.jpg');
      fd.append('art', art);
      if (token) fd.append('turnstile', token);
      return fetch(cfg.config.aiEndpoint + (art === 'freistellen' ? '?art=freistellen' : ''), { method: 'POST', body: fd });
    });
  };

  SockPreview.prototype.template = function (name) {
    var tpls = this.tpls;
    if (!tpls[name]) {
      tpls[name] = loadTemplate(this.base + name + '/', this.v);
      tpls[name].catch(function () { delete tpls[name]; });
    }
    return tpls[name];
  };
  function loadTemplate(b, v) {
    v = v || '';
    return Promise.all([
      loadImage(b + 'leer.jpg' + v, true), loadImage(b + 'schatten.png' + v, true), loadImage(b + 'druck-vorn.png' + v, true), loadImage(b + 'druck-hinten.png' + v, true),
      fetch(b + 'vorlage.json' + v).then(function (r) { return r.json(); })
    ]).then(function (a) { return { leer: a[0], shade: pixels(a[1]), front: pixels(a[2]), back: pixels(a[3]), json: a[4] }; });
  }

  window.GasSockPreview = {
    attach: function (cfg) {
      if (cfg.sock || !cfg.config.sockPreview || !cfg.config.upload) return cfg.sock;
      cfg.sock = new SockPreview(cfg);
      return cfg.sock;
    },
    // für Tests (docs/design/socken-vorschau): einzelne Schritte ohne Konfigurator
    intern: {
      schnittMensch: schnittMensch, tierKopf: tierKopf, maskFromUri: maskFromUri, masksFor: masksFor, groesste: groesste, compose: compose, loadTemplate: loadTemplate, logoKreis: logoKreis,
      schneiden: schneiden, schnittGruppe: schnittGruppe, motive: motive, aufFlaeche: aufFlaeche, einzeln: einzeln, vereinen: vereinen, ohneKopf: ohneKopf, vorlagenArt: vorlagenArt, ausduennen: ausduennen
    }
  };
  // Konfiguratoren, die schon vor diesem Skript gestartet sind
  Array.prototype.forEach.call(document.querySelectorAll('[data-shp]'), function (root) {
    if (root.__shp) window.GasSockPreview.attach(root.__shp);
  });
})();
